module.exports = __webpack_public_path__ + "img/coding@2x.c34fa652.png";